import React from 'react'
import { Button, Form, FormFeedback } from 'reactstrap';
import { FaSave, FaPaperPlane } from 'react-icons/fa'
import axios from 'axios';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import ErrorSwal from '../components/SwalError'
import { useHistory, useLocation } from 'react-router';
import { Switch, Case, Default } from 'react-if'
import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie'


import { LeaveTypeAPI, LeaveCreateAPI, CheckTypeLeave } from './functions/LeaveRequestPage';

const FormData = require('form-data');
const schema = yup.object().shape({
    leaveType: yup
        .string()
        .required("Leave Type is required"),
    dateFrom: yup.string()
        .required('Date From is required')
        .matches(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/, 'Date From must be a valid date in the format YYYY-MM-DD'),
    dateEnd: yup.string()
        .required('Date End is required')
        .matches(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/, 'Date End must be a valid date in the format YYYY-MM-DD'),
    reason: yup.string()
        .required("Reason is required"),

})


const LeaveCreate = () => {

    const history = useHistory();
    const { pathname } = useLocation()
    const TypeLeave = pathname.split("/").pop()

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });
    const { t } = useTranslation()
    const currentLanguageCode = cookies.get('i18next') || 'en'

    const [checked] = React.useState(true)
    const [typeList, setTypeList] = React.useState([])
    const cancelToken = React.useRef(null)
    const [error, setError] = React.useState(null)
    const [leaveType, setLeaveType] = React.useState(TypeLeave)
    const [dfrom, setDFrom] = React.useState(null) //React.useState(moment().format('YYYY-MM-DD'))
    const [tfrom, setTFrom] = React.useState(null)
    const [dend, setDEnd] = React.useState(null)
    const [tend, setTEnd] = React.useState(null)
    const [selectedFile, setSelectedFile] = React.useState(null);
    const [disabled, setDisabled] = React.useState(true);
    const [button, setButton] = React.useState(null)

    // const [dateLeave,setDateLeave] = React.useState(null)

    const getData = async () => {
        try {

            const res_type = await LeaveTypeAPI()
            setTypeList(res_type.data.leaveType);

        } catch (error) {
            if (error?.response?.data) {
                const { data } = error.response
                setError(data.message)
            }
        }

    }

    React.useEffect(() => {
        cancelToken.current = axios.CancelToken.source();

        getData();

        //Check LeaveType can use or not.
        if (TypeLeave !== "request") {
            CheckLeaveToUse(TypeLeave)
        }

        return () => {
            cancelToken.current.cancel();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const handleFile = (e) => {
        setSelectedFile(e.target.files[0])
    }
    const handelAllDay = (e) => {
        if (e.target.checked) {
            setDisabled(true)
        }
        else {
            setDisabled(false)
        }
    }

    const handleClick = value => () => {
        setButton(value)
    }

    const handelChangLeaveType = (e) => {
        setLeaveType(e.target.value)
        //call to api check 
        CheckLeaveToUse(e.target.value)
    }

    const CheckLeaveToUse = async (LeaveTypeId) => {
        await CheckTypeLeave(LeaveTypeId)
            .then((res) => {
                if (parseInt(res.data.boolCheckLeave) === 1) {
                    ErrorSwal({ title: 'Error', text: `${t("t_error_to_leave")}`, icon: 'error' })
                    setLeaveType(0)
                }
            })
            .catch((error) => {
                if (error?.response?.data) {
                    const { data } = error.response
                    setError(data.message)
                }
            })
    }
    const onSubmit = async (data) => {

        try {

            // console.log(data)

            if (data.leaveType === "0" || !data.dateFrom || !data.dateEnd || !data.reason) {
                if(data.leaveType === "0"){
                    // console.log(1111)
                    setError(t("b_leave_type"))
                }

                return;
            }


            if (disabled) {
                data.timeFrom = ''
                data.timeEnd = ''
            }

            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append('leaveType', data.leaveType)
            formData.append('dateFrom', data.dateFrom)
            formData.append('dateEnd', data.dateEnd)
            formData.append('timeFrom', data.timeFrom)
            formData.append('timeEnd', data.timeEnd)
            formData.append('reason', data.reason)

            if (button === 'Send') {
                formData.append('status', 'Send')
            }
            if (button === 'Save') {
                formData.append('status', 'Save')
            }

            await LeaveCreateAPI(formData)
                .then((response) => {

                    if (response.data.statusFlg === 1) {
                        ErrorSwal({ title: 'Success', text: response.data.message, icon: 'success' })
                    }
                    else {
                        ErrorSwal({ title: 'Success', text: response.data.message, icon: 'warning' })
                    }
                })
                .catch(error => {
                    if (error?.response?.data) {
                        const { data } = error.response
                        setError(data.message)
                    }
                })

            history.replace("/Dashboard")

        } catch (error) {
            if (error?.response?.data) {
                const { data } = error.response
                setError(data.message)
            }
        }

    };

    if (error) {
        ErrorSwal({ title: 'Error', text: error, icon: 'error' })
        setError(null);
    }

    return (
        <>

            <div className="card">
                <div className="card-header">
                    <h4 className="card-title"> {t("t_crt_leave")} </h4>
                </div>
                <div className="card-content">
                    <div className="card-body">
                        <Form className="row g-3" onSubmit={handleSubmit(onSubmit)} >
                            <div className="col-md-8">
                                <div className="row mb-1">
                                    <label  className="col-sm-3 col-form-label col-form-label-sm"> {t("t_leave_type")} * :</label>
                                    <div className="col-sm-9">
                                        <Switch>
                                            <Case condition={currentLanguageCode === 'en'}>
                                                <select className={`form-select ${errors.leaveType ? "is-invalid" : ""}`}
                                                    type="select" name="leaveType" id="leaveType" ref={register}

                                                    onChange={handelChangLeaveType}
                                                    value={leaveType}
                                                >
                                                    <option value='0'> {t("b_leave_type")}  </option>
                                                    {
                                                        typeList.map((typ, index) => {
                                                            return (
                                                                <option value={typ.TYPECD} key={index} > {typ.TYPENM}  </option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                                {errors.leaveType && <FormFeedback type="invalid">{errors.leaveType.message} </FormFeedback>}
                                            </Case>
                                            <Case condition={currentLanguageCode === 'th'}>
                                                <select className={`form-select ${errors.leaveType ? "is-invalid" : ""}`}
                                                    type="select" name="leaveType" id="leaveType" ref={register}

                                                    onChange={handelChangLeaveType}
                                                    value={leaveType}
                                                >
                                                    <option value="0" > {t("b_leave_type")}  </option>
                                                    {
                                                        typeList.map((typ, index) => {
                                                            return (
                                                                <option value={typ.TYPECD} key={index} > {typ.TYPENM2}  </option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                                {errors.leaveType && <FormFeedback type="invalid">{errors.leaveType.message} </FormFeedback>}

                                            </Case>
                                            <Case condition={currentLanguageCode === 'jp'}>
                                                <select className={`form-select ${errors.leaveType ? "is-invalid" : ""}`}
                                                    type="select" name="leaveType" id="leaveType" ref={register}

                                                    onChange={handelChangLeaveType}
                                                    value={leaveType}
                                                >
                                                    <option value="0" > {t("b_leave_type")}  </option>
                                                    {
                                                        typeList.map((typ, index) => {
                                                            return (
                                                                <option value={typ.TYPECD} key={index} > {typ.TYPENM3}  </option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                                {errors.leaveType && <FormFeedback type="invalid">{errors.leaveType.message} </FormFeedback>}

                                            </Case>
                                            <Default>
                                                <select className={`form-select ${errors.leaveType ? "is-invalid" : ""}`}
                                                    type="select" name="leaveType" id="leaveType" ref={register}

                                                    onChange={handelChangLeaveType}
                                                    value={leaveType}
                                                >
                                                    <option value="0" > {t("b_leave_type")}  </option>
                                                    {
                                                        typeList.map((typ, index) => {
                                                            return (
                                                                <option value={typ.TYPECD} key={index} > {typ.TYPENM2}  </option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                                {errors.leaveType && <FormFeedback type="invalid">{errors.leaveType.message} </FormFeedback>}

                                            </Default>

                                        </Switch>



                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="row mb-1">
                                    <div className="col-sm-8">
                                        <div className="form-check">
                                            <div className="checkbox">
                                                <input type="checkbox" className="form-check-input"
                                                    name="AllDayFlags"
                                                    id="AllDayFlags"
                                                    onChange={handelAllDay}
                                                    defaultChecked={checked}
                                                />
                                                <label > {t("t_all_day")}</label>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row mb-1">
                                    <label  className="col-sm-4 col-form-label col-form-label-sm">{t("t_date_from")} * :</label>
                                    <div className="col-sm-8">
                                        <input
                                            className={`form-control ${errors.dateFrom ? "is-invalid" : ""}`}
                                            type="date"
                                            name="dateFrom"
                                            id="dateFrom"
                                            placeholder="Date-From"
                                            ref={register}
                                            onChange={(e) => setDFrom(e.target.value)}     // onChange={ (e) => {SetDFrom(e.target.value); handleDateFrom(e)}  } 
                                         
                                            value={dfrom == null ? '' : dfrom}
                                        />
                                        {errors.dateFrom && <FormFeedback type="invalid">{errors.dateFrom.message} </FormFeedback>}


                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row mb-1">
                                    <label  className="col-sm-4 col-form-label col-form-label-sm">{t("t_to")} * :</label>
                                    <div className="col-sm-8">
                                        <input
                                            className={`form-control ${errors.dateEnd ? "is-invalid" : ""}`}
                                            type="date"
                                            name="dateEnd"
                                            id="dateEnd"
                                            placeholder="Date-End"
                                            ref={register}
                                            onChange={(e) => setDEnd(e.target.value)}
                                            value={dend == null ? '' : dend}

                                        />
                                        {errors.dateEnd && <FormFeedback type="invalid">{errors.dateEnd.message} </FormFeedback>}

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row mb-1">
                                    <label  className="col-sm-4 col-form-label col-form-label-sm">{t("t_time_from")} :</label>
                                    <div className="col-sm-8">
                                        <input
                                            className={`form-control ${errors.timeFrom ? "is-invalid" : ""}`}
                                            type="time"
                                            name="timeFrom"
                                            id="timeFrom"
                                            placeholder="Time-From"
                                            ref={register}
                                            // onChange={handleTimeFrom}
                                            onChange={(e) => setTFrom(e.target.value)}
                                            value={tfrom == null ? '' : tfrom}
                                            disabled={disabled}
                                        />
                                        {errors.timeFrom && <FormFeedback type="invalid">{errors.timeFrom.message} </FormFeedback>}

                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row mb-1">
                                    <label  className="col-sm-4 col-form-label col-form-label-sm">{t("t_to")} :</label>
                                    <div className="col-sm-8">
                                        <input
                                            className={`form-control ${errors.timeEnd ? "is-invalid" : ""}`}
                                            type="time"
                                            name="timeEnd"
                                            id="timeEnd"
                                            placeholder="Time-End"
                                            ref={register}
                                            // onChange={handleTimeEnd}
                                            onChange={(e) => setTEnd(e.target.value)}
                                            value={tend == null ? '' : tend}
                                            disabled={disabled}
                                        />
                                        {errors.timeEnd && <FormFeedback type="invalid">{errors.timeEnd.message} </FormFeedback>}

                                    </div>
                                </div>
                            </div>


                            <div className="col-md-6">
                                <div className="row mb-1">
                                    <label  className="col-sm-4 col-form-label col-form-label-sm">{t("t_reason")} * :</label>
                                    <div className="col-sm-8">
                                        <textarea
                                            className={`form-control ${errors.reason ? "is-invalid" : ""}`}
                                            type="textarea"
                                            name="reason"
                                            id="reason"
                                            ref={register}
                                        >
                                        </textarea>
                                        {errors.reason && <FormFeedback type="invalid">{errors.reason.message} </FormFeedback>}

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row mb-1">
                                    <label  className="col-sm-4 col-form-label col-form-label-sm">{t("t_att_file")}:</label>
                                    <div className="col-sm-8">
                                        <input
                                            className="form-control"
                                            type="file"
                                            name="fileupload"
                                            id="fileupload"
                                            size="23"
                                            accept=".jpeg,.jpg,.gif,.png,.pdf"
                                            ref={register}
                                            onChange={handleFile}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                <Button color="primary" type="submit" className="btn btn-success" onClick={handleClick('Send')}>
                                    <FaPaperPlane /> {t("b_send")}
                                </Button>
                                <Button color="primary" type="submit" className="btn btn-primary" onClick={handleClick('Save')}>
                                    <FaSave /> {t("b_save")}
                                </Button>
                            </div>

                        </Form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LeaveCreate
